import { Component } from '@angular/core'
import { SeFeBlockModule } from 'se-fe-block'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeCardHeaderSkeletonComponent } from 'se-fe-card/skeleton'
import { SeFeGridModule } from 'se-fe-grid'
import { SeFeSkeletonModule } from 'se-fe-skeleton'
import { SeFeLabelValuePairSkeletonComponent } from 'se-fe-label-value-pair/skeleton'
import { SeFeHeaderSkeletonComponent } from 'se-fe-header/skeleton'
import { SeFeButtonModule } from 'se-fe-button'

@Component({
  selector: 'se-po-profile-financials-invoices-skeleton',
  standalone: true,
  imports: [
    SeFeBlockModule,
    SeFeHeaderSkeletonComponent,
    SeFeGridModule,
    SeFeButtonModule,
    SeFeLabelValuePairSkeletonComponent,
    SeFeSkeletonModule,
  ],
  template: `
    <se-fe-grid seFeGridOpts>
      @for (_ of invoiceRows; track $index) {
        <se-fe-grid-cell seFeGridOpts="1/1">
          <se-fe-block seFeDataType="outline" [seFeDataSnug]="false" class="skeleton-style">
            <div class="se-fe-theme--reset">
              <se-fe-grid seFeGridOpts="snug justified">
                <se-fe-grid-cell seFeGridOpts>
                  <se-fe-header-skeleton
                    seFeDataSize="small"
                    seFeDataAction="chip|small-short"
                    [seFeDataTitle]="true">
                  </se-fe-header-skeleton>
                </se-fe-grid-cell>
              </se-fe-grid>

              <se-fe-grid seFeGridOpts="snug">
                <se-fe-grid-cell seFeGridOpts>
                  <se-fe-label-value-pair-skeleton></se-fe-label-value-pair-skeleton>
                </se-fe-grid-cell>
                <se-fe-grid-cell seFeGridOpts="shrink">
                  <se-fe-label-value-pair-skeleton></se-fe-label-value-pair-skeleton>
                </se-fe-grid-cell>
              </se-fe-grid>

              <se-fe-grid seFeGridOpts="snug">
                @for (_ of actionButtons; track $index) {
                  <se-fe-grid-cell seFeGridOpts>
                    <se-fe-skeleton-loading [seFeSkeletonLoading]="true">
                      <se-fe-button style="--height: 32px" seFeSkeleton="button|full-small"></se-fe-button>
                    </se-fe-skeleton-loading>
                  </se-fe-grid-cell>
                }
              </se-fe-grid>

            </div>
          </se-fe-block>
        </se-fe-grid-cell>
      }
    </se-fe-grid>
  `,
  styles: [
    `
    .skeleton-style {
      padding: var(--se-container-spacing)
    }
    `
  ]
})
export class ProfileFinancialsInvoicesSkeletonComponent {
  protected readonly invoiceRows = [0, 1]
  protected readonly actionButtons = [0, 1, 2]
}

@Component({
  selector: 'se-po-profile-financials-skeleton',
  standalone: true,
  imports: [
    SeFeCardModule,
    SeFeCardHeaderSkeletonComponent,
    ProfileFinancialsInvoicesSkeletonComponent,
  ],
  template: `
    <se-fe-card>
      <se-fe-card-header-skeleton seFeDataSize="section" [seFeDataHeavyBorder]="true" [seFeDataTitle]="true"></se-fe-card-header-skeleton>
      <se-fe-card-content>
        <se-po-profile-financials-invoices-skeleton></se-po-profile-financials-invoices-skeleton>
      </se-fe-card-content>
    </se-fe-card>
  `,
})
export class ProfileFinancialsSkeletonComponent {}
